import { React, useState, Image } from "react";
import SideBar from "../../Components/SideBar";
import { BallerzToken, BallerzRedirect } from "../../Client/Ballerz.js";
import { useGetRequest } from "../../Client/index.js";
import SkillCard from "../../Components/SkillCard";
// import MobileDropdown from "./MobileDropdown.js";
import MobileFooter from "../../Components/MobileFooter";
import { useLocation } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import HeaderPreRegistration from "../../Components/HeaderPreRegistration";
import UserRow from "./UserRow.js";
import { usePreReg } from "../PreRegContext.js";

function PreRegistration() {
  const [submitted, setSubmitted] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { users, email, bookingReference } = location.state || {};

  const { contextPreReg, setContextPreReg } = usePreReg();

  return (
    <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
      <HeaderPreRegistration bookingReference={contextPreReg} />

      <div className="flex flex-1">
        <main className="flex-1 p-2 sm:p-6 flex justify-center items-start">
          <div className="flex flex-col gap-2 items-center text-center w-full px-4">
            <div className="Kallisto_Bold text-3xl">Select user</div>

            {users?.map((user) => (
              <UserRow
                key={user.esaUserID}
                item={user}
                bookingReference={contextPreReg}
                className="w-4/5 sm:w-[50%]"
              />
            ))}

            <div className="flex justify-center w-4/5 sm:w-1/5 mt-10 gap-4">
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded flex items-center w-full"
                onClick={() =>
                  navigate("/pre-registration/confirm-details", {
                    state: {
                      bookingReference: contextPreReg,
                      email: email,
                    },
                  })
                }
              >
                <span className="Kallisto_Bold text-center w-full">
                  None of the above
                </span>
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default PreRegistration;
